<div *ngIf="isActive" class="filter-modal">
    <div class="container">
        <div class="header">
            <a (click)="close()" class="cancel">Abbrechen</a>
            <div class="title">Filter</div>
            <div class="buttons">
                <button [disabled]="!selectedDeviceCategory" (click)="reset()" class="reset">Reset</button>
                <button [disabled]="!selectedDeviceCategory" (click)="showResults()" class="show-results">Ergebnisse
                    anzeigen
                </button>
            </div>
        </div>
        <div class="content">
            <div class="sub-content">
                <div class="title">Gerätekategorie</div>
                <div class="values product-categories">
                    <bdcp-filter-device-category *ngFor="let category of deviceCategories" [category]="category"
                                                 (selected)="categorySelected(category)"></bdcp-filter-device-category>
                </div>
            </div>
            <div *ngFor="let filterCategory of selectedDeviceCategory?.filterCategories" class="sub-content">
                <div class="title">{{filterCategory.label}}</div>
                <div *ngIf="filterCategory.type === 'checkbox'" class="values checkbox-filters">
                    <bd-checkbox *ngFor="let functionFiter of filterCategory.filters"
                                 [checkbox]="functionFiter"></bd-checkbox>
                </div>
                <bd-radio-group *ngIf="filterCategory.type === 'radio'" class="values radio-filters"
                                [radios]="filterCategory.filters"
                                group="monthlyPrintVolumeFilters"></bd-radio-group>
                <div class="values slider-filters">
                    <bd-slider *ngIf="filterCategory.type === 'slider'"
                               [sliderCategory]="utility.asSliderCategory($any(filterCategory))"></bd-slider>
                </div>
            </div>
            <div *ngIf="selectedDeviceCategory?.filterCategories?.length === 0" class="sub-content">
                <div class="information">Keine weiteren Filterkriterien vorhanden - gesamtes
                    {{selectedDeviceCategory?.portfolioName}} von Brother anzeigen.
                </div>
            </div>
            <div class="sub-content">
                <div class="contact">
                    <div class="header">Nicht die Lösungen, die Sie suchen?</div>
                    <div class="sub-header">Melden Sie sich!</div>
                    <button (click)="requestCallback()" class="contact">Anfrage stellen&nbsp;
                        <i class="fa fa-chevron-right"></i>
                    </button>
                </div>
            </div>
            <div class="footer">
                <button [disabled]="!selectedDeviceCategory" (click)="showResults()" class="bd-red-button">
                    Filterergebnisse
                    anzeigen
                </button>
            </div>
        </div>
    </div>
</div>
